const service = function (
	$filter, 
	Http, 
) {
	"ngInject";

	this.id = (query) => Http.get('/v1/search/id', false, { query });
	this.quick = (data) => Http.get('/v1/search', false, data);
	this.log = (data) => Http.post('/v1/search/log', 'POST', data)

	this.sortOptions = function() {
		return [
			{
				key: 'popularity',
				order: 'desc',
				label: $filter('translate')('sort_popularity')
			},
			{
				key: 'created_at',
				order: 'desc',
				label: $filter('translate')('sort_release_date')
			},
			{
				key: 'stock',
				order: 'desc',
				label: $filter('translate')('sort_supplyhl')
			},
			{
				key: 'stock',
				order: 'asc',
				label: $filter('translate')('sort_supplylh')
			},
			{
				key: 'brand',
				order: 'asc',
				label: $filter('translate')('sort_description')
				
			},
			{
				key: 'price',
				order: 'asc',
				label: $filter('translate')('sort_pricelh')
			},
			{
				key: 'price',
				order: 'desc',
				label: $filter('translate')('sort_pricehl')
			}
		];
	};
	
	
};

export default service;



// WEBPACK FOOTER //
// ./app/components/search/search.service.js